import type { RouteObject } from 'react-router';
import { paths } from '@shared/config/paths';
import { AiPage } from './pages/AiPage';

/** Routes exposées par la feature « ai » à la coquille applicative. */
export const aiRoutes: RouteObject[] = [{ path: paths.ai, element: <AiPage /> }];
